function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "7.5",
  y: "2",
  width: "2",
  height: "12",
  rx: "1",
  fill: "current"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2.5",
  y: "9",
  width: "2",
  height: "12",
  rx: "1",
  transform: "rotate(-90 2.5 9)",
  fill: "current"
}));